module.exports = __webpack_public_path__ + "static/media/creative-quarter-sideview.0add545d.jpg";